<template>
  <div class="h-full w-full flex bg-white duration-300 ease hub-dark:bg-black">
    <div
      class="absolute h-screen w-screen opacity-80 duration-300 ease hub-dark:opacity-90"
      :style="{
        'backgroundImage': `url(${backgroundPath})`,
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
      }" />
    <main class="h-screen w-screen flex">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
import backgroundPath from '@/../assets/background.jpg';
</script>
